import * as React from 'react';
import { Image as KImage } from 'react-konva';
import { getImageRatio } from '@nexxt/common/utils/question';
interface CanvasImageProps {
    getSize: (width: number, height: number, ratio: number) => void;
    src: string;
    containerWidth?: number;
}
interface CanvasImageState {
    image: any;
}
export default class CanvasImage extends React.Component<
    CanvasImageProps,
    CanvasImageState
> {
    state = {
        image: null
    };
    componentDidMount() {
        // save to "this" to remove "load" handler on unmount
        const image = new window.Image();
        image.src = this.props.src;

        image.onload = () => {
            // this.props.getSize(image.width, image.height);
            const newImage = getImageRatio(image, 500);
            image.width = this.props.containerWidth || newImage.image.width;
            image.height = newImage.image.height;

            this.props.getSize(image.width, image.height, newImage.ratio);

            this.setState({
                image: image
            });
        };
    }

    render() {
        return <KImage image={this.state.image} />;
    }
}
